import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {ChromePicker, BlockPicker} from "react-color";
import reactCSS from 'reactcss';
import {Tooltip} from "@material-ui/core";
import {chartColors} from "../ChartUtils/chartColors";

class ColorPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayColorPicker: false
        }
    }

    handleClose = () => {
        this.setState({displayColorPicker: false})
    };

    handleClick = () => {
        this.setState({displayColorPicker: !this.state.displayColorPicker})
    };

    render() {
        const {name, values, path, value, onChange, pickerType} = this.props;
        const {displayColorPicker} = this.state;
        const styles = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: this.props.value || 'rgba(0,0,0,1)'
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });
        return (
            <div>
                <div style={styles.swatch} onClick={this.handleClick}>
                    <Tooltip title={'Select Color'}>
                        <div style={styles.color}/>
                    </Tooltip>
                </div>
                {displayColorPicker ? <div style={styles.popover}>
                    <div style={styles.cover} onClick={this.handleClose}/>
                    {pickerType === 'blockPicker' ? (
                        <BlockPicker
                            colors={chartColors}
                            color={value}
                            name={name}
                            onChangeComplete={(color) => onChange(color, name, values, path)}/>
                    ) : (
                        <ChromePicker
                            colors={chartColors}
                            color={value}
                            name={name}
                            onChangeComplete={(color) => onChange(color, name, values, path)}/>
                    )}
                </div> : null}
            </div>
        );
    }

}

ColorPicker.propTypes = {
    onChange: PropTypes.func.isRequired,
    //  value: PropTypes.array,
};

export default ColorPicker;